// This file was automatically generated by the Soy compiler.
// Please don't edit this file by hand.
// source: src/com/yext/socialstorm/app/views/Social/eventDialogTitle.soy

/**
 * @fileoverview Templates in namespace yext.social.Social.eventDialogTitle.
 * @public
 */

goog.provide('yext.social.Social.eventDialogTitle');
goog.require("yext");

goog.require('goog.soy');
goog.require('soy');
goog.require('soydata.VERY_UNSAFE');


/**
 * @param {!yext.social.Social.eventDialogTitle.title.Params} opt_data
 * @param {(?goog.soy.IjData|?Object<string, *>)=} opt_ijData
 * @return {!goog.soy.data.SanitizedHtml}
 * @suppress {checkTypes}
 */
yext.social.Social.eventDialogTitle.title = function(opt_data, opt_ijData) {
  opt_ijData = /** @type {!goog.soy.IjData} */ (opt_ijData);
  /** @type {?} */
  const titleMessage = opt_data.titleMessage;
  let $output = '<div class="dialog-title-wrapper"' + (goog.DEBUG && soy.$$debugSoyTemplateInfo ? ' data-debug-soy="yext.social.Social.eventDialogTitle.title src/com/yext/socialstorm/app/views/Social/eventDialogTitle.soy:5"' : '') + '><div class="dialog-title">' + soy.$$escapeHtml(titleMessage) + '</div><div class="required-prompt required">';
  /** @desc  */
  const MSG_UNNAMED = yext.getMsg('Required', {}, {html: true});
  $output += MSG_UNNAMED;
  $output += '<span class="required-legend"><i class="required-circle"></i></span></div></div>';
  return soydata.VERY_UNSAFE.ordainSanitizedHtml($output);
};
/**
 * @typedef {{
 *  titleMessage: ?,
 * }}
 */
yext.social.Social.eventDialogTitle.title.Params;
if (goog.DEBUG) {
  /** @type {string} */
  yext.social.Social.eventDialogTitle.title.soyTemplateName = 'yext.social.Social.eventDialogTitle.title';
}
